import Vue from 'vue'
import Azure from '@/utilities/plugin/azure'
import Configuration from '@/utilities/service/Configuration'

export const AZURE_KEYS = {
  clientId: Configuration.value('azureClientId'),
  tenantId: Configuration.value('azureTenantId'),
  secret: Configuration.value('azureSecret'),
}

const AZURE_URI = '/'

export default Vue.use(Azure, {
  apiKey: AZURE_KEYS,
  uri: AZURE_URI,
})
